exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropzone[data-v-0c075ab2] {\n    width: 100%;\n    height: 200px;\n    border: 2px solid aquamarine;\n}\n.bar[data-v-0c075ab2] { width: 300px; height: 2px; background: #eee\n}\n.progress[data-v-0c075ab2] { height: 2px; background: darkturquoise\n}\n\n", ""]);

// exports
